var SearchResultsObservable_1;
import { __decorate } from "tslib";
import readyState from 'ready-state';
import { observable } from '@slickdeals/durango/dist/javascript/decorators/observable';
import { getDataAttributeValues } from '@slickdeals/durango/dist/javascript/utilities/dom';
/** The name of the module */
export const name = 'SearchResultsObservable';
/** The event name fired by this observable */
export const eventName = 'search';
let SearchResultsObservable = SearchResultsObservable_1 = class SearchResultsObservable {
    /**
       * Create an Observable instance
       */
    constructor() {
        readyState.domready.then(this.init.bind(this));
    }
    /**
       * Trigger a notification from this observable instance
       */
    init() {
        const data = {
            product_ids: SearchResultsObservable_1.getSearchResultThreadIds(),
            keywords: SearchResultsObservable_1.getSearchKeyword(),
        };
        this.notify(data, eventName);
    }
    /**
       * Get keyword used for current search.
       */
    static getSearchKeyword() {
        const keyWordElement = document.querySelector('input[data-module-name="globalSearch"]');
        if (keyWordElement) {
            return keyWordElement.value;
        }
        return '';
    }
    /**
       * Get a list of all search result threadIds on the current page
       */
    static getSearchResultThreadIds() {
        const results = document.querySelectorAll('#searchResults [data-thread-id], #searchResults [data-threadid]');
        const dataAttributeName = (results.length && results[0].hasAttribute('data-threadid')) ? 'threadid' : 'thread-id';
        return getDataAttributeValues(Array.from(results), dataAttributeName, true);
    }
};
SearchResultsObservable = SearchResultsObservable_1 = __decorate([
    observable
], SearchResultsObservable);
export default SearchResultsObservable;
